// Per-zone SEO landing page metadata.
// Used by /app/frontend/src/pages/ZonePage.jsx and the sitemap.
export const ZONES = [
  {
    slug: "carro-attrezzi-roma-eur",
    name: "Roma EUR",
    title: "Carro Attrezzi Roma EUR | Soccorso Stradale H24 - 06 9763 6222",
    description:
      "Carro attrezzi EUR Roma attivo 24 ore su 24. Recupero auto, traino veicoli, batteria scarica, soccorso stradale rapido nel quartiere EUR. Chiama subito 06 9763 6222.",
    h1: "Carro Attrezzi Roma EUR H24",
    intro:
      "Servizio di carro attrezzi e soccorso stradale rapido nel quartiere EUR di Roma. Interveniamo in viale Europa, Cristoforo Colombo, Laurentina, P. Marconi e in tutte le zone limitrofe, attivi 24 ore su 24 per traino auto, recupero veicoli in panne e batteria scarica.",
    keywords:
      "carro attrezzi EUR, soccorso stradale EUR Roma, traino auto EUR, carro attrezzi Roma EUR H24",
  },
  {
    slug: "carro-attrezzi-ostia",
    name: "Ostia",
    title: "Carro Attrezzi Ostia | Soccorso Stradale Rapido H24 - Roma",
    description:
      "Carro attrezzi Ostia H24: traino auto, recupero veicoli incidentati, soccorso stradale rapido a Ostia, Lido e Acilia. Attivi giorno e notte. Chiama 06 9763 6222.",
    h1: "Carro Attrezzi Ostia H24",
    intro:
      "Carro attrezzi e soccorso stradale a Ostia, Ostia Lido e Acilia. Recuperiamo auto e moto in qualsiasi punto di via del Mare, Cristoforo Colombo, Ostia Antica e zone limitrofe, con personale qualificato e pagamento anche con carta.",
    keywords:
      "carro attrezzi Ostia, soccorso stradale Ostia, traino auto Ostia, carro attrezzi Ostia Lido",
  },
  {
    slug: "carro-attrezzi-fiumicino",
    name: "Fiumicino",
    title: "Carro Attrezzi Fiumicino | Soccorso Stradale H24 - 06 9763 6222",
    description:
      "Carro attrezzi Fiumicino e aeroporto Leonardo da Vinci H24. Traino, recupero auto e moto, batteria scarica. Intervento rapido a Fiumicino e dintorni. 06 9763 6222.",
    h1: "Carro Attrezzi Fiumicino H24",
    intro:
      "Servizio di carro attrezzi a Fiumicino città, zona aeroporto Leonardo da Vinci, Isola Sacra, Fregene e Maccarese. Disponibili 24/7 per traino, recupero auto incidentate, auto in panne e avviamento batteria sul posto.",
    keywords:
      "carro attrezzi Fiumicino, soccorso stradale Fiumicino, traino auto Fiumicino, carro attrezzi aeroporto Fiumicino",
  },
  {
    slug: "carro-attrezzi-tiburtina",
    name: "Tiburtina",
    title: "Carro Attrezzi Tiburtina | Soccorso Stradale Roma H24",
    description:
      "Carro attrezzi Tiburtina Roma 24 ore. Recupero auto, traino, batteria scarica nel quartiere Tiburtino. Chiama subito: 06 9763 6222.",
    h1: "Carro Attrezzi Tiburtina H24",
    intro:
      "Carro attrezzi e soccorso stradale nel quartiere Tiburtina di Roma: via Tiburtina, Casal Bertone, Pietralata, Portonaccio, San Lorenzo e zone vicine. Operativi notte e giorno per ogni emergenza su gomma.",
    keywords:
      "carro attrezzi Tiburtina, soccorso stradale Tiburtina Roma, traino auto Tiburtina",
  },
  {
    slug: "carro-attrezzi-prenestina",
    name: "Prenestina",
    title: "Carro Attrezzi Prenestina | Soccorso Stradale Roma H24",
    description:
      "Carro attrezzi Prenestina H24: recupero auto, traino, auto in panne in via Prenestina, Centocelle, Quarticciolo, Tor Sapienza. Intervento rapido. 06 9763 6222.",
    h1: "Carro Attrezzi Prenestina H24",
    intro:
      "Soccorso stradale e carro attrezzi sulla Prenestina e nelle zone Centocelle, Quarticciolo, Tor Sapienza, Alessandrino e Villa Gordiani. Squadra operativa 24 ore al giorno, prezzo chiaro al telefono.",
    keywords:
      "carro attrezzi Prenestina, soccorso stradale Prenestina, traino auto Centocelle",
  },
  {
    slug: "carro-attrezzi-tuscolana",
    name: "Tuscolana",
    title: "Carro Attrezzi Tuscolana | Soccorso Stradale Roma H24",
    description:
      "Carro attrezzi Tuscolana Roma attivo 24/7. Traino, recupero auto, batteria scarica in via Tuscolana, Cinecittà, Quadraro, Don Bosco. 06 9763 6222.",
    h1: "Carro Attrezzi Tuscolana H24",
    intro:
      "Carro attrezzi e soccorso stradale lungo la via Tuscolana e nei quartieri Cinecittà, Quadraro, Don Bosco, Tuscolano. Recupero auto, scooter e moto a qualsiasi ora del giorno e della notte.",
    keywords:
      "carro attrezzi Tuscolana, soccorso stradale Tuscolana, traino auto Cinecittà",
  },
  {
    slug: "carro-attrezzi-aurelia",
    name: "Aurelia",
    title: "Carro Attrezzi Aurelia | Soccorso Stradale Roma H24",
    description:
      "Carro attrezzi Aurelia Roma H24. Recupero auto, traino veicoli, batteria scarica in via Aurelia, Boccea, Casalotti, Battistini. Chiama 06 9763 6222.",
    h1: "Carro Attrezzi Aurelia H24",
    intro:
      "Soccorso stradale e carro attrezzi nel quadrante ovest di Roma: via Aurelia, Boccea, Casalotti, Battistini, Cornelia. Disponibili 24/7 per recupero auto, traino e auto in panne.",
    keywords:
      "carro attrezzi Aurelia, soccorso stradale Aurelia Roma, traino auto Boccea",
  },
  {
    slug: "carro-attrezzi-appia",
    name: "Appia",
    title: "Carro Attrezzi Appia | Soccorso Stradale Roma H24",
    description:
      "Carro attrezzi via Appia Roma H24: traino auto, recupero veicoli, batteria scarica in Appia Nuova, Appia Antica, Furio Camillo, Colli Albani. 06 9763 6222.",
    h1: "Carro Attrezzi Appia H24",
    intro:
      "Carro attrezzi e soccorso stradale sulla via Appia (Nuova e Antica), Furio Camillo, Colli Albani, San Giovanni. Una telefonata e arriviamo: pagamento contanti o carta sul posto.",
    keywords:
      "carro attrezzi Appia, soccorso stradale Appia Roma, traino auto Appia Nuova",
  },
];

export const getZone = (slug) => ZONES.find((z) => z.slug === slug);
